import React , {useEffect} from 'react'

import { useDispatch,useSelector } from 'react-redux'
import IntlMessages from "util/IntlMessages"
import { DataGetAction,DataRequestAction } from 'redux/actions/http'
const PatientHealthReport = ({record}) => {
   
   
    const userInfo = JSON.parse(localStorage.getItem('userInfo'));
    const reportProps = useSelector(state => state.report)
    const {  patientModelVisible,reportDetails } = reportProps
    const checkIfReadOrUnread = () =>{
        console.log('=========here========')
        if(patientModelVisible && record._id === reportDetails._id ){


            if(record.readStatus === 'unRead' && record.assignTo === userInfo._id){
                dispatch(DataRequestAction('PUT', 'updateReportStatus', {reportId : record._id}, '', 'updateReportStatus', false))
            }

            
        }
     
    }

    useEffect(checkIfReadOrUnread, [patientModelVisible])

    const dispatch = useDispatch()
    const togglePatientReportModal = (record) => {
        dispatch({
            type: 'patientReport_Modal',
            payload :  record
        })
        dispatch(DataGetAction('getDailyOverview', '', 'gettingDailyOverview'))
    }
    return (
        <div>
            <span onClick={() => togglePatientReportModal(record)} className="gx-link"><IntlMessages id="report.view" /></span>
            
        </div>
    )
}

export default PatientHealthReport
